<script setup lang="ts">
import { useTypedIntl } from "@/locales/typed-intl";

import ConfirmationDialog from "@/components/ui/dialog/confirmation-dialog.vue";

const visible = defineModel<boolean>("visible", { required: true });

const emit = defineEmits<{
  (event: "abandon"): void;
}>();

const { t, k } = useTypedIntl();
</script>

<template>
  <ConfirmationDialog
    v-model="visible"
    delete-mode
    :callback="() => emit('abandon')"
    :cancel-text="t(k.tools.siteManagement.siteTreeStructure.bulkCategory.abandonSelection.continueEdition)"
    :title="t(k.tools.siteManagement.siteTreeStructure.bulkCategory.abandonSelection.title)"
    :subtitle="t(k.tools.siteManagement.siteTreeStructure.bulkCategory.abandonSelection.message)"
    :submit-text="t(k.tools.siteManagement.siteTreeStructure.bulkCategory.abandonSelection.abandon)"
  />
</template>
